import { render, staticRenderFns } from "./ReservationTypeChip.vue?vue&type=template&id=0b6cca5a&scoped=true&"
import script from "./ReservationTypeChip.vue?vue&type=script&lang=js&"
export * from "./ReservationTypeChip.vue?vue&type=script&lang=js&"
import style0 from "./ReservationTypeChip.vue?vue&type=style&index=0&id=0b6cca5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6cca5a",
  null
  
)

export default component.exports